import React, { useState, useEffect } from 'react';
import './add-user.css';
import { instance } from '../axios-api/axios-api';
import { Link, useNavigate } from 'react-router-dom';
import ImgCrop from 'antd-img-crop';
import { Upload } from 'antd';
import '../css/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const SOCIAL_FIELDS = [
  { name: 'phone', label: 'Phone', placeholder: '' },
  { name: 'whatsapp', label: 'Whatsapp', placeholder: 'CountryCode + Number' },
  {
    name: 'whatsappBusiness',
    label: 'Whatsapp Business',
    placeholder: 'CountryCode + Number',
  },
  { name: 'googleReview', label: 'Google Review', placeholder: 'URL' },
  { name: 'mail', label: 'Mail', placeholder: '' },
  { name: 'twitter', label: 'Twitter', placeholder: 'Twitter Username' },
  { name: 'linkedin', label: 'Linkedin', placeholder: 'Username' },
  { name: 'instagram', label: 'Instagram', placeholder: 'Username' },
  { name: 'facebook', label: 'Facebook', placeholder: 'Username' },
  { name: 'website', label: 'Website', placeholder: '' },
  { name: 'location', label: 'Location', placeholder: 'latitude,longitude' },
  { name: 'youtube', label: 'Youtube', placeholder: 'URL' },
  { name: 'dribble', label: 'Dribble', placeholder: 'Username' },
  { name: 'vimeo', label: 'Vimeo', placeholder: 'Username' },
  { name: 'spotify', label: 'Spotify', placeholder: 'Username' },
  { name: 'tiktok', label: 'Tiktok', placeholder: 'UserId' },
  { name: 'pinterest', label: 'Pinterest', placeholder: 'Username' },
  { name: 'soundcloud', label: 'Soundcloud', placeholder: 'URL', hidden: true },
  { name: 'warwick', label: 'Warwick', placeholder: 'URL', hidden: true },
  { name: 'telegram', label: 'Telegram', placeholder: 'Username' },
  { name: 'cute', label: 'Cute', placeholder: 'URL', hidden: true },
  { name: 'snapchat', label: 'Snapchat', placeholder: 'Username' },
  { name: 'threads', label: 'Threads', placeholder: 'Username' },
  { name: 'tumblr', label: 'Tumblr', placeholder: 'Username', hidden: true },
  { name: 'behance', label: 'Behance', placeholder: 'Username' },
  { name: 'dropbox', label: 'Dropbox', placeholder: 'URL' },
  { name: 'skype', label: 'Skype', placeholder: 'Skype Id' },
  { name: 'paypal', label: 'Paypal', placeholder: 'Username', hidden: true },
  { name: 'flickr', label: 'Flickr', placeholder: 'URL' },
  { name: 'rss', label: 'Rss', placeholder: 'URL', hidden: true },
];

function SocialLinkField({ field, value, checked, onInputChange, onToggleChange }) {
  return (
    <li className="mt-0 mb-3 mb-md-5" hidden={field.hidden}>
      <div>
        <div className="switch-label">
          <label htmlFor={field.name}>{field.label}</label>
          <label className="switch">
            <input
              type="checkbox"
              className="toggle"
              id={field.name}
              checked={checked || false}
              onChange={onToggleChange}
            />
            <span className="slider"></span>
          </label>
        </div>
        <input
          type="text"
          className="form-control"
          id={field.name}
          value={value || ''}
          onChange={onInputChange}
          placeholder={field.placeholder}
        />
      </div>
    </li>
  );
}

export function AddUser() {
  const [userDataDetails, setUserDataDetails] = useState({
    username: '',
    designation: '',
    company: '',
  });

  const [imageUrl, setImageUrl] = useState(null);

  const navigate = useNavigate();
  const jwtToken = localStorage.getItem('jwtToken');

  const [formValues, setFormValues] = useState(
    SOCIAL_FIELDS.reduce((acc, field) => ({ ...acc, [field.name]: '' }), {
      android: '',
    })
  );

  const [checkBoxValues, setCheckBoxValues] = useState(
    SOCIAL_FIELDS.reduce((acc, field) => ({ ...acc, [field.name]: false }), {
      android: false,
    })
  );

  useEffect(() => {
    if (jwtToken) {
      instance.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
      instance.defaults.headers.post['Content-Type'] = 'application/json';
      instance
        .get('/user/current-user')
        .then(response => {
          let dataArray = response.data ? response.data.dataArray : [];

          let userData = response.data ? response.data.user : [];

          let imageArray = response.data ? response.data.image : {};

          if (imageArray && imageArray.id) {
            const t = new Uint8Array(imageArray.data.data);
            const blob = new Blob([t.buffer], { type: 'image/jpeg' });
            const imageUrl = URL.createObjectURL(blob);
            setImageUrl(imageUrl);
          }
          if (userData) {
            setUserDataDetails(userData);
          }

          if (dataArray && dataArray.length > 0) {
            const obj = dataArray.reduce((acc, curr) => {
              acc[curr.name] = curr;
              return acc;
            }, {});

            setFormValues(prev =>
              Object.keys(prev).reduce(
                (acc, name) => ({
                  ...acc,
                  [name]: obj[name] ? obj[name].value : null,
                }),
                {}
              )
            );
            setCheckBoxValues(prev =>
              Object.keys(prev).reduce(
                (acc, name) => ({
                  ...acc,
                  [name]: obj[name] ? obj[name].active : false,
                }),
                {}
              )
            );
          }
        })
        .catch(error => {
          const err = error?.response?.data?.message
            ? error?.response.data.message
            : error?.message;
          toast.error(err);

          const statusCode = error?.response?.data?.statusCode
            ? error.response.data.statusCode
            : error.message;

          if (statusCode == 401) {
            setTimeout(() => {
              logout();
            }, 3000);
          }
        });
    }
  }, [jwtToken]);

  const handleInputChange = event => {
    const { id, value } = event.target;

    setFormValues({ ...formValues, [id]: value });
  };

  const userDataDetailsHandler = event => {
    const { id, value } = event.target;

    setUserDataDetails({ ...userDataDetails, [id]: value });
  };

  const handleCheckBoxChange = event => {
    const { id } = event.target;

    const val = !checkBoxValues[id];

    setCheckBoxValues({ ...checkBoxValues, [id]: val });
  };

  const handleSaveContact = () => {
    if (!userDataDetails.username) {
      toast.error('Name is mandatory');
      return;
    }

    const userDataRequest = Object.keys(formValues).map(name => ({
      name,
      value: formValues[name],
      active: checkBoxValues[name],
    }));

    const requestBody = {
      username: userDataDetails.username,
      designation: userDataDetails.designation
        ? userDataDetails.designation
        : '',
      company: userDataDetails.company ? userDataDetails.company : '',
      data: userDataRequest,
    };

    instance.defaults.headers.common['Authorization'] = 'Bearer ' + jwtToken;
    instance.defaults.headers.post['Content-Type'] = 'application/json';
    instance
      .post('/user/store-user-data', requestBody)
      .then(response => {
        toast.success(response.statusText);
      })
      .catch(error => {
        const err = error?.response?.data?.message
          ? error?.response.data.message
          : error?.message;
        toast.error(err);
      });
  };

  const logout = () => {
    localStorage.removeItem('jwtToken');
    navigate('/login');
  };

  const onChangeImage = async file => {
    const formData = new FormData();
    if (file) {
      setImageUrl(URL.createObjectURL(file));

      formData.append('file', file);
      instance.defaults.headers.post['Content-Type'] = 'multipart/form-data';
      instance
        .post('/user/upload', formData, {
          responseType: 'arraybuffer',
        })
        .then(response => {
          if (response) {
            const blob = new Blob([response.data], { type: 'image/jpeg' });
            const imageUrl = URL.createObjectURL(blob);
            setImageUrl(imageUrl);
          }
        })
        .catch(error => {
          const err = error?.response?.data?.message
            ? error?.response.data.message
            : error?.message;
          toast.error(err);
        });
    }
  };

  useEffect(() => {
    return () => {
      URL.revokeObjectURL(imageUrl);
    };
  }, [imageUrl]);

  const onPreview = async file => {
    let src = file.url;
    if (!src) {
      src = await new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  return (
    <div>
      <header>
        <nav className="navbar navbar-expand-lg navbar-light bg-transparent py-0">
          <div className="container-fluid">
            <Link to="/">
              <span className="logo mt-0">
                <img src="../assets/images/logo.svg" alt="logo" />
              </span>
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarNav"
              aria-controls="navbarNav"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link active" to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/change-password">
                    Change Password
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="tel:+971542747073">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <section>
        <div className="profile_con mt-5">
          <span className="profile">
            <span className="pic">
              <img
                className="img-fluid"
                src={imageUrl ? imageUrl : '../assets/images/user.png'}
                alt=""
              />
            </span>
          </span>

          <h1 className="User_id">
            {userDataDetails.user_id ? userDataDetails.user_id : ''}
          </h1>

          <div className="divider new-divider ">
            <span></span>
          </div>
          <ImgCrop rotationSlider className="image-preview">
            <Upload
              beforeUpload={file => {
                onChangeImage(file);
                return false;
              }}
              onPreview={onPreview}
              maxCount={1}
              showUploadList={false}
            >
              <span className="image-preview-text btn btn-gradient">
                + Upload
              </span>
            </Upload>
          </ImgCrop>
          <div>
            <div></div>

            <div className="user_details">
              <label htmlFor="username" className="form-label">
                Username
              </label>
              <h3>
                <input
                  type="text"
                  className="form-control"
                  id="username"
                  value={
                    userDataDetails.username ? userDataDetails.username : ''
                  }
                  onChange={userDataDetailsHandler}
                  placeholder=""
                />
              </h3>

              <label htmlFor="designation" className="form-label mt-3">
                Designation
              </label>
              <h3>
                <input
                  type="text"
                  className="form-control"
                  id="designation"
                  value={
                    userDataDetails.designation
                      ? userDataDetails.designation
                      : ''
                  }
                  onChange={userDataDetailsHandler}
                  placeholder=""
                />
              </h3>

              <label htmlFor="company" className="form-label mt-3">
                Company
              </label>
              <h3>
                <input
                  type="text"
                  className="form-control"
                  id="company"
                  value={userDataDetails.company ? userDataDetails.company : ''}
                  onChange={userDataDetailsHandler}
                  placeholder=""
                />
              </h3>
            </div>
          </div>

          <div className="divider new-divider">
            <span></span>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="icons p-0 w-100">
                <ul id="myList_add" className="px-3">
                  {SOCIAL_FIELDS.map(field => (
                    <SocialLinkField
                      key={field.name}
                      field={field}
                      value={formValues[field.name]}
                      checked={checkBoxValues[field.name]}
                      onInputChange={handleInputChange}
                      onToggleChange={handleCheckBoxChange}
                    />
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div>
          <ToastContainer theme="dark" />
        </div>
        <ul className="btm_btn cls">
          <li>
            <button onClick={handleSaveContact}>SAVE</button>
          </li>
          <Link
            to={'/' + (userDataDetails.user_id ? userDataDetails.user_id : '')}
          >
            <li>
              <button>Preview</button>
            </li>
          </Link>

          <li>
            <button onClick={logout}>Logout</button>
          </li>
        </ul>
      </section>
      <footer>
        <ul className="fnav">
          <li>
            <a
              href="mailto:digiccard@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              Digiccard@gmail.com
            </a>
          </li>
          <li>
            <Link to="/terms_and_condition">Terms & Condition</Link>
          </li>
        </ul>
      </footer>
    </div>
  );
}
